var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9697C16.8252 20.9697 20.8154 16.9795 20.8154 12.1543C20.8154 7.32031 16.8252 3.33887 11.9912 3.33887C7.16602 3.33887 3.18457 7.32031 3.18457 12.1543C3.18457 16.9795 7.1748 20.9697 12 20.9697ZM12 15.0986C9.23145 15.0986 7.13086 16.2061 6.31348 17.3223C5.08301 15.96 4.32715 14.1494 4.32715 12.1543C4.32715 7.90039 7.74609 4.47266 11.9912 4.47266C16.2451 4.47266 19.6729 7.90039 19.6816 12.1543C19.6816 14.1494 18.9258 15.96 17.6865 17.3223C16.8691 16.2061 14.7686 15.0986 12 15.0986ZM12 13.5957C13.6875 13.6045 14.9971 12.1631 14.9971 10.2822C14.9971 8.51562 13.6699 7.03906 12 7.03906C10.3301 7.03906 8.99414 8.51562 9.00293 10.2822C9.01172 12.1631 10.3125 13.5781 12 13.5957Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.80f8bebb284c436ff34b8cf771a09530.svg";
export { ForwardRef as ReactComponent };